define(["./create"], function(create){
	// module:
	//		dojo/errors/CancelError

	/*=====
	return function(){
		// summary:
		//		Default error if a promise is canceled without a reason.
	};
	=====*/

	return create("CancelError", null, null, { dojoType: "cancel" });
});



//////////////////
// WEBPACK FOOTER
// ./src/lib/dojo/errors/CancelError.js
// module id = 28
// module chunks = 0